import React from 'react';

import SearchWidgetUI from '../../../../stories/components/hotels/SRP/SearchWidgetUI/SearchWidgetUI';
import useSearchWidget from '../../../hooks/useSearchWidget';
import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';
import usePrevious from '../../../hooks/usePrevious'; // REFACTOR
import scrollToTop from '../../../utils/scrollToTop';

import {pushga} from 'ga-utils';
import {gaConfig} from '@stencil/hotels-config';
import {nonNullable} from '@stencil/type-guards';
import {useSelector} from 'react-redux';
import {selectedPropertyNameSelector} from '@stencil/hotels-common-reducer/src/selectors';

const {SrpGAEvents} = gaConfig;

const SearchWidget = ({isDetailsPage = false, isSrp = false}) => {
  const {
    checkin,
    checkout,
    destination,
    roomString,
    autosuggestHandler,
    updateQueryCaller,
  } = useSearchWidget();

  const selectedPropertyName = useSelector(selectedPropertyNameSelector);

  const prevDestinationId = usePrevious(destination?._id);
  const destinationChanged =
    nonNullable(prevDestinationId) &&
    nonNullable(destination?._id) &&
    prevDestinationId !== destination?._id;

  const openInNewTab = destinationChanged && isDetailsPage;

  const detailToSRPFlag = isDetailsPage ? destinationChanged && destination?.t !== 'hotel' : false;

  const {onSearch} = useNavigateForSearchWidget();
  React.useEffect(() => {
    if (destinationChanged) {
      onSearch({
        openInNewTab: openInNewTab,
        resetOldFilter: true,
        detailToSrpFlag: detailToSRPFlag,
      }); // clearing filters on destination change
    }
  }, [destinationChanged, openInNewTab, detailToSRPFlag]);

  const gaHandler = (type: 'location' | 'calendarClicked' | 'pax', val) => {
    switch (type) {
      case 'location':
        pushga({
          eventCategory: SrpGAEvents.hotelSrpModifyClicked.category,
          eventAction: SrpGAEvents.hotelSrpModifyClicked.action.locationChanged,
          eventLabel: val || '',
        });
        break;

      case 'calendarClicked':
        pushga({
          eventCategory: SrpGAEvents.hotelSrpModifyClicked.category,
          eventAction: SrpGAEvents.hotelSrpModifyClicked.action.checkinCheckoutChanged,
        });
        break;

      case 'pax':
        pushga({
          eventCategory: SrpGAEvents.hotelSrpModifyClicked.category,
          eventAction: SrpGAEvents.hotelSrpModifyClicked.action.roomGuestsChanged,
        });
        break;

      default:
        break;
    }
  };

  const searchInputValue = isDetailsPage ? selectedPropertyName : destination && destination.n;

  return (
    <SearchWidgetUI
      updateQueryCaller={updateQueryCaller}
      autosuggestHandler={autosuggestHandler}
      roomString={roomString}
      checkin={checkin}
      checkout={checkout}
      searchInputValue={searchInputValue}
      gaHandler={gaHandler}
      updateSearch={() => {
        onSearch({openInNewTab: openInNewTab, detailToSrpFlag: detailToSRPFlag});
        scrollToTop();
      }}
    />
  );
};

export default SearchWidget;
